
export enum UserRole {
    ADMIN = 'admin',
    USER = 'user',
    PRO = 'pro',
    BETA = 'beta',
}

export interface Permission {
    route: string;
    allowedRoles: UserRole[];
}

export const MENU_PERMISSIONS: Permission[] = [
    { route: '/', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/transactions', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/fixed-expenses', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/cards', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/groups', allowedRoles: [UserRole.ADMIN, UserRole.PRO] },
    { route: '/wallets', allowedRoles: [UserRole.ADMIN, UserRole.PRO] },
    { route: '/analytics', allowedRoles: [UserRole.ADMIN, UserRole.PRO] },
    { route: '/settings', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/pro', allowedRoles: [UserRole.USER] },
    { route: '/help', allowedRoles: [UserRole.ADMIN, UserRole.USER, UserRole.PRO, UserRole.BETA] },
    { route: '/admin', allowedRoles: [UserRole.ADMIN] },
];
